/** Staging vs production API hosts (must match Railway env). */
export const STAGING_FRONTEND_HOST = 'testai.flashprepared.com';
export const STAGING_API_URL = 'https://testapi.flashprepared.com';
export const PRODUCTION_FRONTEND_HOST = 'ai.flashprepared.com';
export const PRODUCTION_API_URL = 'https://api.flashprepared.com';

/**
 * Resolve API base URL for the current deployment.
 * Staging UI always uses testapi, regardless of a mis-set REACT_APP_API_URL build arg.
 */
export function resolveApiBaseUrl(buildTimeUrl?: string): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === STAGING_FRONTEND_HOST) {
      return STAGING_API_URL;
    }
    if (host === PRODUCTION_FRONTEND_HOST) {
      return PRODUCTION_API_URL;
    }
  }

  const raw = (buildTimeUrl ?? process.env.REACT_APP_API_URL ?? '').trim();
  let url =
    raw.startsWith('http://') && !raw.includes('localhost')
      ? raw.replace('http://', 'https://')
      : raw;

  if (typeof window !== 'undefined') {
    const isHttpsPage = window.location?.protocol === 'https:';
    const isProductionFrontend = /flashprepared\.com|flash-em\.com/i.test(
      window.location?.hostname || ''
    );
    if (
      (isHttpsPage || isProductionFrontend) &&
      typeof url === 'string' &&
      url.startsWith('http://')
    ) {
      url = url.replace('http://', 'https://');
    }
  }

  return url || 'http://localhost:8000';
}

/** Resolved API origin without a trailing slash. */
export function getApiBaseUrl(): string {
  return resolveApiBaseUrl(process.env.REACT_APP_API_URL).replace(/\/$/, '');
}

/** Build a full API URL for fetch calls (always HTTPS on staging/production UI). */
export function apiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalized}`;
}
